import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'apiManagerApi',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: 'apiManagerApi',
  baseQuery,
  tagTypes: ['ApiKeys'],
  endpoints: builder => ({
    getApiKeys: builder.query<any, any>({
      query: filters => ({
        url: endpoints.API_KEYS + '/keys',
        method: 'GET',
        params: filters,
      }),
      providesTags: ['ApiKeys'],
    }),
    getApiKeyById: builder.query<any, string>({
      query: id => ({
        url: endpoints.API_KEYS + '/keys/' + id,
        method: 'GET',
      }),
      providesTags: ['ApiKeys'],
    }),
    getApiPermissions: builder.query<any, void>({
      query: () => ({
        url: endpoints.API_KEYS + '/permissions',
        method: 'GET',
      }),
    }),
    createApiKey: builder.mutation<any, any>({
      query: data => ({
        url: endpoints.API_KEYS + '/keys',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ApiKeys'],
    }),
    updateApiKey: builder.mutation<any, any>({
      query: ({ id, ...data }) => ({
        url: endpoints.API_KEYS + '/keys/' + id,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['ApiKeys'],
    }),
    deleteApiKey: builder.mutation<any, string>({
      query: id => ({
        url: endpoints.API_KEYS + '/keys/' + id,
        method: 'DELETE',
      }),
      invalidatesTags: ['ApiKeys'],
    }),
  }),
});

export const { actions: ApiManagerActions } = slice;

export const useApiManagerSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: ApiManagerActions,
    useGetApiKeysQuery: api.useLazyGetApiKeysQuery,
    useGetApiKeyByIdQuery: api.useLazyGetApiKeyByIdQuery,
    useGetApiPermissionsQuery: api.useLazyGetApiPermissionsQuery,
    useCreateApiKeyMutation: api.useCreateApiKeyMutation,
    useUpdateApiKeyMutation: api.useUpdateApiKeyMutation,
    useDeleteApiKeyMutation: api.useDeleteApiKeyMutation,
  };
};
